module.exports = __webpack_public_path__ + "img/巴戟天.d072296c.jpg";